export const mixinListCommon = {
  data() {
    return {};
  },
  deactivated() {
    this.$refs.elSearch.isShowBottom = false;
  }
};
